import { Temporal } from './temporal';

/** Current instant (replaces `new Date()` for timestamps) */
export function nowInstant(): Temporal.Instant {
  return Temporal.Now.instant();
}

/** Current calendar date (replaces `new Date()` for date-only contexts) */
export function nowPlainDate(): Temporal.PlainDate {
  return Temporal.Now.plainDateISO();
}

/** Instant occurring `duration` from now (replaces `new Date(Date.now() + ms)`) */
export function expiresAfter(duration: Temporal.DurationLike): Temporal.Instant {
  return Temporal.Now.instant().add(duration);
}

/** Parse an ISO 8601 date string (YYYY-MM-DD) into a PlainDate */
export function plainDateFrom(iso: string): Temporal.PlainDate {
  return Temporal.PlainDate.from(iso);
}

/** Parse an ISO 8601 datetime string into an Instant */
export function instantFrom(iso: string | Temporal.Instant): Temporal.Instant {
  if (typeof iso === 'string') {
    return Temporal.Instant.from(iso);
  }
  return iso;
}

/** Create an Instant from epoch milliseconds (replaces `new Date(ms)`) */
export function instantFromEpochMs(ms: number): Temporal.Instant {
  return Temporal.Instant.fromEpochMilliseconds(ms);
}

/**
 * Normalises a Temporal date input to a `PlainDate` in the given time zone.
 * Instants are converted to their wall-clock date in the target zone, so
 * "23:30 UTC" becomes "2025-11-20" in Europe/Prague (UTC+1).
 */
export function toPlainDate(
  input: Temporal.PlainDate | Temporal.Instant,
  timeZone: string
): Temporal.PlainDate {
  if (input instanceof Temporal.Instant) {
    return input.toZonedDateTimeISO(timeZone).toPlainDate();
  }
  return input;
}
